inputs-search-textfield
  div(class="form-group row { error: opts.errors }")
    label.col-md-4.col-form-label
      | { opts.label }
      span.text-danger(if="{ opts.required }") &nbsp;*
    .col-md-8
      input(class="form-control form-control { opts.klass }" name="{ opts.name }" placeholder="{ opts.placeholder }" type="text" value="{ opts.value }" onInput="{this.onInput}" onChange="{this.onChange}")
  script(type="typescript").
    this.mixin('inputs.textfield');
